module.exports = __webpack_public_path__ + "img/inst.12d5a2bd.svg";